// extracted by mini-css-extract-plugin
module.exports = {"promotionButton":"_217e93a","promotionCloseButton":"_7062166","promotionOpenButton":"_f5a0d1e","freeBetIcon":"_44f66f5","promotionRemoveButton":"_4642532"};